import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/logo_sm.png'


const _hoisted_1 = { class: "flex-shrink-0" }
const _hoisted_2 = {
  key: 0,
  class: "navbar navbar-expand-lg navbar-dark bg-main"
}
const _hoisted_3 = { class: "container px-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "#",
    height: "45"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_6 = {
  key: 0,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_7 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_8 = { class: "nav-item dropdown" }
const _hoisted_9 = {
  key: 0,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_10 = {
  key: 1,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_11 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-right-from-bracket" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_15 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_16 = { class: "nav-item dropdown" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownAdmon",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, "Envío de Mensajes", -1)
const _hoisted_18 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownAdmon"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hospital" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-hospital-user" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-nurse" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-apple-whole" }, null, -1)
const _hoisted_23 = { class: "nav-item dropdown" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, "Administración", -1)
const _hoisted_25 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-users" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bed" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-doctor" }, null, -1)
const _hoisted_29 = { class: "nav-item dropdown" }
const _hoisted_30 = {
  key: 0,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog2",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_31 = {
  key: 1,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog21",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_32 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-right-from-bracket" }, null, -1)
const _hoisted_35 = {
  key: 2,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_36 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = { class: "nav-item dropdown" }
const _hoisted_39 = {
  key: 0,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_40 = {
  key: 1,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_41 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-right-from-bracket" }, null, -1)
const _hoisted_44 = {
  key: 3,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_45 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_46 = { class: "nav-item" }
const _hoisted_47 = { class: "nav-item" }
const _hoisted_48 = { class: "nav-item dropdown" }
const _hoisted_49 = {
  key: 0,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_50 = {
  key: 1,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_51 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-right-from-bracket" }, null, -1)
const _hoisted_54 = {
  key: 4,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_55 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_56 = { class: "nav-item" }
const _hoisted_57 = { class: "nav-item" }
const _hoisted_58 = { class: "nav-item dropdown" }
const _hoisted_59 = {
  key: 0,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_60 = {
  key: 1,
  class: "nav-link dropdown-toggle",
  id: "navbarDropdownBlog",
  href: "#",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_61 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdownBlog"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-home" }, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-right-from-bracket" }, null, -1)
const _hoisted_64 = {
  class: "py-1",
  id: "scroll-target"
}
const _hoisted_65 = { class: "container px-3 my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.toggleNavBar())
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            (_ctx.perfil <= 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", _hoisted_8, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_9, _toDisplayString(_ctx.user.displayName), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_10, "Mi Cuenta"))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inicio "),
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cerrarSesion()))
                          }, [
                            _createTextVNode("Cerrar Sesión  "),
                            _hoisted_13
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.perfil == 5 || _ctx.perfil == 6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("ul", _hoisted_18, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/direccion",
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Dirección   "),
                              _hoisted_19
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/recepcion"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Recepción  "),
                              _hoisted_20
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/enfermeria"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Enfermería  "),
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/nutricion"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Nutrición  "),
                              _hoisted_22
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("ul", _hoisted_25, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            to: "/usuarios",
                            class: "dropdown-item"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Usuarios   "),
                              _hoisted_26
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/habitaciones"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Habitaciones  "),
                              _hoisted_27
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/doctores"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Personal  "),
                              _hoisted_28
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_29, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_30, _toDisplayString(_ctx.user.displayName), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_31, "Mi Cuenta"))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_32, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Inicio "),
                              _hoisted_33
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cerrarSesion()))
                          }, [
                            _createTextVNode("Cerrar Sesión  "),
                            _hoisted_34
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.perfil == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("ul", _hoisted_36, [
                    _createElementVNode("li", _hoisted_37, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/nutricion"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Nutrición")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_38, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_39, _toDisplayString(_ctx.user.displayName), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_40, "Mi Cuenta"))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_41, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inicio "),
                              _hoisted_42
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cerrarSesion()))
                          }, [
                            _createTextVNode("Cerrar Sesión  "),
                            _hoisted_43
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.perfil == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("ul", _hoisted_45, [
                    _createElementVNode("li", _hoisted_46, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/recepcion"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Recepción")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_47, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/habitaciones"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Habitaciones")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_48, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_49, _toDisplayString(_ctx.user.displayName), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_50, "Mi Cuenta"))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_51, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inicio "),
                              _hoisted_52
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cerrarSesion()))
                          }, [
                            _createTextVNode("Cerrar Sesión  "),
                            _hoisted_53
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.perfil == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                  _createElementVNode("ul", _hoisted_55, [
                    _createElementVNode("li", _hoisted_56, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/enfermeria"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Enfermería")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_57, [
                      _createVNode(_component_router_link, {
                        class: "nav-link",
                        to: "/habitaciones"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Habitaciones")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", _hoisted_58, [
                      (_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_59, _toDisplayString(_ctx.user.displayName), 1))
                        : _createCommentVNode("", true),
                      (!_ctx.user)
                        ? (_openBlock(), _createElementBlock("a", _hoisted_60, "Mi Cuenta"))
                        : _createCommentVNode("", true),
                      _createElementVNode("ul", _hoisted_61, [
                        _createElementVNode("li", null, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inicio "),
                              _hoisted_62
                            ]),
                            _: 1
                          }),
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cerrarSesion()))
                          }, [
                            _createTextVNode("Cerrar Sesión  "),
                            _hoisted_63
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createVNode(_component_Toast),
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}